import { Header } from './Header';

export const Layout = ({ children }) => {
  return (
    <div className="min-h-screen bg-background font-sans antialiased" data-testid="layout-wrapper">
      <Header />
      <main className="container mx-auto py-8 px-4 max-w-7xl" data-testid="main-content">
        {children}
      </main>
    </div>
  );
};

export default Layout;
